import { toast } from '@shared/ui';
import { TEXTS } from '../texts';

export type WebPlayerSettingsControllerProps = {
  bindingCode: string;
};

export const useWebPlayerSettingsController = ({ bindingCode }: WebPlayerSettingsControllerProps) => {
  const onCopyClick = () => {
    navigator.clipboard.writeText(
      `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/web-player/${bindingCode}`
    );

    toast.info(TEXTS.LINK_COPIED);
  };

  return { onCopyClick };
};
